import { render, staticRenderFns } from "./AccPayHeader.vue?vue&type=template&id=22e2cf75&"
import script from "./AccPayHeader.vue?vue&type=script&lang=js&"
export * from "./AccPayHeader.vue?vue&type=script&lang=js&"
import style0 from "./AccPayHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports